// frontend/src/components/LogoutButton.jsx

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { logoutUser } from '../services/authService';
import { clearStoredSession } from '../hooks/useHashSession';

/**
 * Botón de cierre de sesión unificado y adaptable.
 *
 * Maneja tanto sesiones anónimas (por hash) como autenticadas (por JWT).
 * Acepta un prop `isAuthenticated` para determinar el comportamiento.
 *
 * @param {object} props
 * @param {boolean} [props.isAuthenticated=false] - Si es `true`, ejecuta el flujo de logout para usuarios autenticados.
 */
export default function LogoutButton({ isAuthenticated = false }) {
  const navigate = useNavigate();
  const { _ } = useTranslation();

  const handleLogout = () => {
    // Limpia la sesión basada en hash (rol, hash, parentHash).
    clearStoredSession();
    // Limpia el origen de navegación.
    sessionStorage.removeItem('group_origin');

    // --- Lógica Condicional ---
    if (isAuthenticated) {
      // Flujo para usuario autenticado con JWT
      logoutUser(); // Llama al servicio que elimina el jwt_token.
      sessionStorage.removeItem('selected_group'); // Limpia el grupo seleccionado.
      navigate('/login'); // Redirige a la página de inicio de sesión.
    } else {
      // Flujo para usuario anónimo (o como fallback)
      sessionStorage.removeItem('jwt_token'); // Limpieza de seguridad por si acaso.
      navigate('/'); // Redirige a la página principal.
    }
  };

  return (
    <button
      className="button-logout icon-button"
      onClick={handleLogout}
      title={_('Logout')}
    >
      <FontAwesomeIcon icon="sign-out-alt" className="mr-1" />
    </button>
  );
}